import { render, staticRenderFns } from "./TransferReturnsList.vue?vue&type=template&id=2dcc3fe4&scoped=true&"
import script from "./TransferReturnsList.vue?vue&type=script&lang=js&"
export * from "./TransferReturnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc3fe4",
  null
  
)

export default component.exports